const isOnMaintenance = () => {
  return (
    process.env.REACT_APP_MAINTENANCE_START_DATE &&
    new Date() < new Date(process.env.REACT_APP_MAINTENANCE_END_DATE) &&
    new Date() >= new Date(process.env.REACT_APP_MAINTENANCE_START_DATE)
  )
}

export { isOnMaintenance }
